export const constructStrRep = (obj) => {
  if (obj.str_representation) return obj.str_representation;
  return "Roll";
};

export const editUrl = ({ id }) => `/errand-settings/roles/handle-role/${id}`;

export const overiewUrl = () => `/errand-settings/roles`;
